import styled from 'styled-components';

import colors from 'styles/colors';
import { CLOSE_ICON_SIZE } from 'components/Wrapper';

export const SubmissionFormStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 24px 24px calc(${CLOSE_ICON_SIZE} * 2);
`;

export const SubmissionBasicDataStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  row-gap: 16px;
`;

export const SubmissionFormDescriptionStyled = styled.div`
  margin-bottom: 24px;

  h2 {
    margin: 0 0 16px;
    padding: 0;
  }
  h3 {
    margin: 0 0 8px;
    padding: 0;
  }
  p {
    margin: 0;
    padding: 0;
  }
`;

export const SubmissionFormContentStyled = styled.div`
  width: 100%;
  min-width: 0;
`;

export const TabBarStyled = styled.div`
  display: flex;
  overflow-x: auto;
  border-bottom: 1px solid ${colors.gray_scale4};
  background-color: ${colors.white};
  scrollbar-width: thin;
`;

export const TabItemStyled = styled.button<{ active: boolean }>`
  flex-shrink: 0;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: ${({ active }) => (active ? '600' : '400')};
  color: ${({ active }) => (active ? colors.brand_2 : colors.black)};
  background: none;
  border: none;
  border-bottom: 2px solid ${({ active }) => (active ? colors.brand_2 : 'transparent')};
  cursor: pointer;
  white-space: nowrap;
  transition:
    color 0.15s,
    border-color 0.15s;

  &:hover {
    color: ${colors.brand_2};
  }
`;

export const TabBodyStyled = styled.div`
  padding: 24px 0;
`;

export const TabBodyContentStyled = styled.div`
`;

export const FormSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  min-width: 0;

  p {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
    color: #000;
    white-space: pre-wrap;
  }
`;

export const FormSectionContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 16px;
  width: 100%;
  min-width: 0;

  h4 {
    margin: 0 0 4px;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.5;
    color: #000;
  }

  p {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
    color: #000;
    white-space: pre-wrap;
  }

  ul {
    display: initial;
    list-style: initial;
    padding-left: 20px;

    li {
      display: list-item;
      font-weight: 400;
      font-size: 14px;
      line-height: 1.5;
      color: #000;
      white-space: pre-wrap;

      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }
`;

export const FormListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 8px;
  width: 100%;
  min-width: 0;
  
  &:empty {
    display: none;
  }
`;

export const FormListActionsStyled = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
  width: 100%;
`;

interface FormListItemStyledProps {
  $isAdmin?: boolean;
}

export const FormActionsStyled = styled.div<FormListItemStyledProps>`
  position: sticky;
  z-index: 10;
  bottom: ${({ $isAdmin }) => ($isAdmin ? '-16px' : 0)};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  margin: -24px;
  padding: 24px;
  background: #fff;
`;
